var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuPages(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7 4.26279V1.66279H1.3V4.26279H11.7ZM11.7 5.56279H1.3V10.7628H11.7V5.56279ZM0.65 0.362793H12.35C12.5224 0.362793 12.6877 0.431275 12.8096 0.553174C12.9315 0.675072 13 0.840402 13 1.01279V11.4128C13 11.5852 12.9315 11.7505 12.8096 11.8724C12.6877 11.9943 12.5224 12.0628 12.35 12.0628H0.65C0.477609 12.0628 0.312279 11.9943 0.190381 11.8724C0.0684819 11.7505 0 11.5852 0 11.4128V1.01279C0 0.840402 0.0684819 0.675072 0.190381 0.553174C0.312279 0.431275 0.477609 0.362793 0.65 0.362793ZM1.95 6.21279H3.9V9.46279H1.95V6.21279ZM1.95 2.31279H3.25V3.61279H1.95V2.31279ZM4.55 2.31279H5.85V3.61279H4.55V2.31279Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuPages);
export default __webpack_public_path__ + "static/media/menu-pages.8647c42d827a2c1c67d6d619be82c261.svg";
export { ForwardRef as ReactComponent };